import "shared/extensions/string";

import { ReactElement, cloneElement } from "react";

import classNames from "classnames";

export type IconProps = {
  caption?: string;
  icon?: ReactElement;
  fgColour?: string;
  bgColour?: string;
  hasDropShadow?: boolean;
  useSetWidth?: boolean;
};

export const Icon = ({ caption = "", icon, fgColour = "text-brand", bgColour = "bg-white", hasDropShadow = true, useSetWidth = true }: IconProps) => {
  const iconWithProps = icon
    ? cloneElement(icon, {
        className: classNames("w-12"),
      })
    : null;
  return (
    <div className="flex flex-col items-center">
      <div
        className={classNames("inline-flex", "justify-center", "items-center", "rounded-full", fgColour, bgColour, {
          "shadow-md": hasDropShadow,
          "w-full h-12 w-12": useSetWidth,
        })}
      >
        {iconWithProps}
      </div>
      {caption.isNullOrEmpty() ? null : <p className="pt-3 text-center text-caption">{caption}</p>}
    </div>
  );
};
